import { db } from '@react-native-firebase/database';
import StyleSheetRW from 'core/StyleSheetRW';
import { getLocalStorageItem } from 'core/helpers';
import { push, ref, remove, update } from 'firebase/database';
import React, { useCallback, useEffect, useState } from 'react';
import { ActivityIndicator, Dimensions } from 'react-native';
import { MOBILE_VIEW_WIDTH } from 'res/constants';
import { generateRandomUid } from 'src/commons';
import { calculateTotalDuration, checkIsWeekend, formatDate, formatDateLikeCalendar, formatTimerDuration } from 'src/utils/Date&TimeUtils';
import { fetchUserName } from 'src/utils/UserUtils';
import Dialog from './Dialog';
import 'jspdf-autotable';
import generateTimeTrackingPDF from 'src/utils/PDFReportUtils';
import DropDownField from './DropDownField';
import TimerStartIcon from "res/img/timerStartIcon.png";
import TimerStopIcon from "res/img/timerStopIcon.png";
import LateClockIcon from "res/img/late_clock.png";
import warning from "res/img/warning.png";
import moment from 'moment';
import { ITimeRecords } from 'src/interfaces/ITimeRecord';
import TimeDurationColumn from './TimeDurationColumn';
import HyperlinkSummary from './HyperlinkSummary';


interface TimeTrackingTableProps {
    TimeTrackingRecords: ITimeRecords;
    getUserTimeRecords: () => void;
    userDetailsScreen?: boolean;
    scrollContainerRef?: React.RefObject<HTMLDivElement>;
    UserData?: any;
    projectNameData?: any
}

const TimeTrackingTable: React.FC<TimeTrackingTableProps> = ({ TimeTrackingRecords, getUserTimeRecords, userDetailsScreen = false, scrollContainerRef, UserData, projectNameData }) => {
    const [selectedRow, setSelectedRow] = useState<any>("");
    const [userName, setUserName] = useState('')
    const [newRowStartTime, setNewRowStartTime] = useState<string>("00:00");
    const [newRowProjectName, setNewRowProjectName] = useState<any>("");
    const [newRowTaskSummary, setNewRowTaskSummary] = useState<any>("");
    const [newRowEndTime, setNewRowEndTime] = useState<string>("00:00");
    const [isNewRowVisible, setIsNewRowVisible] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [showAlertToast, setShowAlertToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [recordEntryDate, setRecordEntryDate] = useState("");
    const [recordEntryUid, setRecordEntryUid] = useState<any>(null);
    const [handleAddClick, setHandleAddClick] = useState<boolean>(false);
    const [isDateWithinThreeDays, setIsDateWithinThreeDays] = useState<boolean>(false);
    const [dropdownPosition, setDropdownPosition] = useState({ x: 0, y: 0, visible: false });
    const [timeTrackingMonthData, setTimeTrackingMonthData] = useState<any>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const screenWidth = Dimensions.get('window').width;

    const tableHeadstyle = { ...styles.tableHead, display: screenWidth < MOBILE_VIEW_WIDTH ? 'none' : 'table-cell' };
    const tableDataStyle = { ...styles.tableData1, display: screenWidth < MOBILE_VIEW_WIDTH ? 'none' : 'table-cell' };
    const mobileTableDataStyle = { ...styles.tableData1, display: screenWidth < MOBILE_VIEW_WIDTH ? 'table-cell' : 'none', maxWidth: "130px" };
    let loggedinUser: any = null;
    let projectName = "";
    let isWeekend;
    const userEmail = getLocalStorageItem("loggedinUser").email;
    const handleRowClick = useCallback((event: any, entry: any, date: any) => {
        event.preventDefault();
        const container = scrollContainerRef?.current;
        if (container) {
            const containerRect = container.getBoundingClientRect();
            const x = Math.min(event.clientX, containerRect.right - 150); // Adjust the right boundary
            const y = Math.min(event.clientY, containerRect.bottom - 70); // Adjust the bottom boundary
            setDropdownPosition({ x, y, visible: true });
        }
        setRecordEntryDate(date)

        setSelectedRow(entry === selectedRow ? "" : entry);
        setHandleAddClick(false)
        setIsNewRowVisible(false)
        const currentDate = new Date();
        const recordEntryDate = new Date(date);
        const timeDifference = currentDate.getTime() - recordEntryDate.getTime();
        setIsDateWithinThreeDays(timeDifference / (1000 * 3600 * 24) <= 3);

    }, [selectedRow, scrollContainerRef]);

    const handleDeleteEntry = async (e: React.MouseEvent<HTMLSpanElement>, recordEntryData: any, recordEntryDate: string) => {
        e.stopPropagation();
        setRecordEntryDate(recordEntryDate)
        setRecordEntryUid(recordEntryData.uid)
        setShowToast(true)
        setToastMessage(`Do you want to delete slot  from ${recordEntryData.startTime ? formatTime(recordEntryData.startTime, false) : ""} to ${recordEntryData.endTime ? formatTime(recordEntryData.endTime, false) : ""}`)
    };

    const handleConfirm = async () => {
        try {
            if (UserData) {
                loggedinUser = UserData.id
            } else {
                loggedinUser = getLocalStorageItem("loggedinUser").uid;
            }

            if (loggedinUser) {
                const dbRef = ref(db, `timeRecord/${loggedinUser}/${recordEntryDate}/${recordEntryUid}`);
                await remove(dbRef)
                    .then(() => {
                        console.log("Entry deleted successfully!");
                        setSelectedRow("");
                        setRecordEntryDate("");
                        setRecordEntryUid(null);
                        setShowToast(false)
                        getUserTimeRecords();
                    })
                    .catch((error) => {
                        console.error("Failed to delete entry:", error);
                        setShowToast(false)
                        setSelectedRow("");
                    });
            }
        } catch (error) {
            console.error("Error deleting entry: ", error);
        }
    }

    const handleAddNewEntry = async () => {
        if (!newRowProjectName) {
            setToastMessage("Please select the Project Name")
            setShowAlertToast(true)
            return
        }
        if (!newRowTaskSummary) {
            setToastMessage("Please add the Task Summary")
            setShowAlertToast(true)
            return
        }

        const today = formatDate(new Date(), "YYYY-MM-DD");
        if (recordEntryDate === today) {
        const startTimeDate = new Date(`${recordEntryDate}T${newRowStartTime}:00`);
        const currentDate = new Date();
        
        if (startTimeDate > currentDate) {
            setToastMessage("Start time cannot be in the future for today's entries");
            setShowAlertToast(true);
            return;
        }
        }


        
        setIsLoading(true)
        try {
            if (UserData) {
                loggedinUser = UserData.id
            } else {
                loggedinUser = getLocalStorageItem("loggedinUser").uid;
            }
            if (loggedinUser)
            {
                const dbRef = ref(
                    db,
                    `timeRecord/${loggedinUser}/${recordEntryDate}`
                );
                const currentTime = new Date().getTime()

                const data = {
                    startTime: formatTime(newRowStartTime, true),
                    endTime: formatTime(newRowEndTime, true),
                    updatedAt:currentTime,
                    duration: calculateDuration(newRowStartTime, newRowEndTime),
                    projectName: newRowProjectName.title,
                    taskSummary: newRowTaskSummary,

                }
                await push(dbRef, data)
                    .then((resData: any) => {
                        setIsLoading(false)
                        setIsNewRowVisible(false);
                        setHandleAddClick(false);
                        setNewRowStartTime("00:00");
                        setNewRowEndTime("00:00");
                        setNewRowProjectName("");
                        setNewRowTaskSummary("");
                        getUserTimeRecords();
                    })
                    .catch((error) => {
                        setIsLoading(false)
                        console.error("Failed to save data:", error);
                    });
            }
        } catch (error) {
            setIsLoading(false)
            console.error("Error adding document: ", error);
        }
    };

    const formatTime = (rawTimeValue: string, isInput: boolean) => {
        const [hours, minutes, second, meridiem] = rawTimeValue.split(/:| /);
        const formattedHours = (parseInt(hours, 10) % 12) || 12;
        if (isInput) {
            const meridiemForInput = parseInt(hours, 10) < 12 ? 'AM' : 'PM';
            return `${formattedHours}:${minutes}:00 ${meridiemForInput}`;
        } else {
            return `${formattedHours}:${minutes} ${meridiem}`;
        }
    };
    

    const calculateDuration = (startTime: string, endTime: string): string => {
        // Parse start time components
        const startComponents = startTime.split(':');
        const startHour = parseInt(startComponents[0]);
        const startMinute = parseInt(startComponents[1]);

        const endComponents = endTime.split(':');
        const endHour = parseInt(endComponents[0]);
        const endMinute = parseInt(endComponents[1]);

        let durationMinutes = (endHour * 60 + endMinute) - (startHour * 60 + startMinute);
        if (durationMinutes < 0) {
            durationMinutes += 24 * 60;
        }

        const hours = Math.floor(durationMinutes / 60);
        const minutes = durationMinutes % 60;

        const formattedDuration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;

        return formattedDuration;
    };


    const isAddButtonDisabled = newRowStartTime === "00:00" || newRowEndTime === "00:00";

    const handleAddNew = (e: React.MouseEvent<HTMLSpanElement>) => {
        e.stopPropagation();
        setIsNewRowVisible(true);
        setSelectedRow("");

        setTimeout(() => {
            const newRowElement = document.getElementById("newRowElement");
            if (newRowElement) {
                newRowElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        }, 0);
    };

    const handleMobileAddNew = (e: React.MouseEvent<HTMLSpanElement>) => {
        e.stopPropagation();
        setIsNewRowVisible(true);
        setHandleAddClick(true);

        setTimeout(() => {
            const newRowElement = document.getElementById("mobileNewRowElement");
            if (newRowElement) {
                newRowElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        }, 0);
    }


    useEffect(() => {
    const currentDate = new Date();
    const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const datesInMonth = [];
    for (let d = currentDate; d >= firstDateOfMonth; d.setDate(d.getDate() - 1)) {
        const date = new Date(d);
        datesInMonth.unshift(date);
    }

    const monthDataWithRecords = datesInMonth.map(date => {
        const dateString = formatDate(date, "YYYY-MM-DD");
        const recordsForDate = TimeTrackingRecords.find(record => record.date === dateString);
        let records = recordsForDate ? [...recordsForDate.records] : [{ startTime: "", endTime: "", duration: "", uid: generateRandomUid(20) }];
        
        
        records.sort((firstRecord, secondRecord) => {
            if (!firstRecord.startTime || !secondRecord.startTime) return 0; // Handle empty start times
            const timeA = moment(firstRecord.startTime, 'h:mm:ss A').valueOf();
            const timeB = moment(secondRecord.startTime, 'h:mm:ss A').valueOf();
            return timeA - timeB;
        });
        
        return {
            date: dateString,
            records: records
        };
        

    });

    setTimeTrackingMonthData(monthDataWithRecords.reverse());
}, [TimeTrackingRecords]);

    useEffect(() => {
        const getUser = async () => {
            const name = await fetchUserName()
            setUserName(name);
        };

        getUser();

        const scrollContainer = scrollContainerRef?.current;
        const handleSelectedRow = () => {
            const isMobile = window.innerWidth < MOBILE_VIEW_WIDTH;
            if (!isMobile) {
                setSelectedRow("");
            }
        };

        document.body.addEventListener('click', handleSelectedRow);
        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleSelectedRow);
        }

        return () => {
            document.body.removeEventListener('click', handleSelectedRow);
            if (scrollContainer) {
                scrollContainer.removeEventListener("scroll", handleSelectedRow);
            }
        };
    }, []);

    // utilities.ts or a similar utility file

const isOnTime = (updatedAt: string,startTime: string, endTime?: string ,date: string ): boolean => {
    // Format the time string to match the correct format (e.g., "h:mm A")
    // console.log("Updated At", updatedAt)
    // console.log("Start Time", startTime)
    // console.log("End Time", endTime)
    // console.log("Date",date)
    const convertTimeToMoment = (timeStr: string,date: string): moment.Moment => {
            return moment(`${date} ${timeStr}`, "YYYY-MM-DD hh:mm:ss A");
    };

    const updatedAtMoment = moment(Number(updatedAt));
    // console.log('Updated At Moment',updatedAtMoment)


    if (endTime) {
        const endTimeMoment = convertTimeToMoment(endTime,date);
        // console.log('End Time Moment',endTimeMoment)
        // console.log("Result wrt end time",updatedAtMoment.isSame(endTimeMoment, 'minute'))
        return updatedAtMoment.isSame(endTimeMoment, 'minute');  
        
    } else {
        const startTimeMoment = convertTimeToMoment(startTime,date);
        return updatedAtMoment.isSame(startTimeMoment, 'minute');  
    }
    };   
    // console.log("Time Tracking month data",timeTrackingMonthData)


    return (
        <>
            <div style={{ position: userDetailsScreen ? undefined : "relative", width: "100%", fontSize: 12, fontWeight: '300', fontFamily: "Outfit", marginTop: "10px", marginBottom: "10px" }}>
                {(!userDetailsScreen && timeTrackingMonthData.length > 1) &&
                    <div style={{ width: '100%', height: 20 }}>
                        <button onClick={() => generateTimeTrackingPDF(timeTrackingMonthData, userEmail)} style={styles.buttonStyle}>
                            <div style={styles.buttonText}>Export as PDF</div></button>
                    </div>
                }
                {!userDetailsScreen && <h2 style={{ ...styles.tableHeading, marginTop: screenWidth < MOBILE_VIEW_WIDTH ? "90px" : "" }}>Timer Records</h2>}
                <div style={{ overflowX: "scroll" }}>
                    <table id="table1" style={{ ...styles.tableStyle, height: "100%", overflow: "hidden" }}>
                        <thead>
                            <tr style={{ backgroundColor: '#2F4858', color: '#FFFFFF' }}>
                                <th style={tableHeadstyle}>Day</th>
                                <th style={tableHeadstyle}>Project Name</th>
                                <th style={styles.tableHead}>Date</th>
                                <th style={styles.tableHead}>Start Time</th>
                                <th style={styles.tableHead}>End Time</th>
                                <th style={tableHeadstyle}>Duration</th>
                                <th style={tableHeadstyle}>Task Summary</th>

                            </tr>
                        </thead>
                        <tbody>
                            {timeTrackingMonthData.length > 0 && timeTrackingMonthData.map((TimeTrackingRecordEntry: any, index: any) => {
                                let totalDuration;
                                if (TimeTrackingRecordEntry?.records.length > 1) {
                                    totalDuration = calculateTotalDuration(TimeTrackingRecordEntry?.records);
                                }
                                isWeekend = checkIsWeekend(TimeTrackingRecordEntry.date)
                                const isToday = TimeTrackingRecordEntry.date === formatDate(new Date(), "YYYY-MM-DD");
                                const backgroundColor = TimeTrackingRecordEntry.records[0].uid === selectedRow.uid
                                    ? '#0000FF33'
                                    : isWeekend
                                        ? '#2F485860'
                                        : index % 2 === 0 ? '#2F48581A' : '#D8E6DC';
                                return (
                                    <React.Fragment key={index}>

                                        <div style={{ fontSize: 0, width: 0 }}>{projectName = TimeTrackingRecordEntry.records[0].projectName}</div>

                                        <tr
                                            onContextMenu={(e) => handleRowClick(e, TimeTrackingRecordEntry.records[0], TimeTrackingRecordEntry.date)}
                                            onClick={screenWidth <= MOBILE_VIEW_WIDTH ? (e) => handleRowClick(e, TimeTrackingRecordEntry.records[0], TimeTrackingRecordEntry.date) : undefined}
                                            style={{ backgroundColor }}
                                        >
                                            <td style={{ display: screenWidth < MOBILE_VIEW_WIDTH ? 'none' : 'table-cell', padding: '15px' }}>{formatDateLikeCalendar(TimeTrackingRecordEntry.date, "dddd")}</td>
                                            <td style={tableDataStyle}>{TimeTrackingRecordEntry.records[0].projectName}</td>
                                            <td style={screenWidth < MOBILE_VIEW_WIDTH ? { padding: '15px' } : styles.tableData1}>{formatDate(TimeTrackingRecordEntry.date, "DD MMM, YY")}</td>
                                            <td style={styles.tableData1}>
                                                <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                                    {TimeTrackingRecordEntry.records[0].startTime ? (
                                                        <>
                                                            <img src={TimerStartIcon} alt="TimerStartIcon" width={25} height={25} />
                                                            {
                                                                formatTime(TimeTrackingRecordEntry.records[0].startTime, false)
                                                            }
                                                        </>
                                                    ) : ""}

                                                </span>
                                            </td>
                                            <td style={styles.tableData1}>
                                                <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                                    {TimeTrackingRecordEntry?.records[0]?.endTime ? (
                                                        <>
                                                            <img src={TimerStopIcon} alt="TimerStopIcon" width={25} height={25} />
                                                            {
                                                                formatTime(TimeTrackingRecordEntry.records[0].endTime, false)
                                                            }
                                                        </>
                                                    ) : (
                                                        <>
                                                            {TimeTrackingRecordEntry.records[0].startTime && !isToday && (
                                                                <>
                                                                    <img src={warning} alt="warning" width={25} height={25} />
                                                                    <span>Add End Time</span>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </span>
                                            </td>
                                            <td style={tableDataStyle}>
                                               <TimeDurationColumn
                                                date={TimeTrackingRecordEntry.date}
                                                record={TimeTrackingRecordEntry.records[0]}
                                                formatTimerDuration={formatTimerDuration}
                                                isOnTime={isOnTime}
                                                LateClockIcon={LateClockIcon}
                                                />
                                            </td>
                                            <td style={{ ...tableDataStyle, maxWidth: "200px", wordBreak: "break-word" }}>
                                                <HyperlinkSummary text={TimeTrackingRecordEntry?.records?.[0]?.taskSummary || ''} />
                                            </td>

                                            {TimeTrackingRecordEntry.records[0].uid === selectedRow.uid && (
                                                <div style={{ position: 'fixed', top: dropdownPosition.y, left: dropdownPosition.x, zIndex: 100 }}>
                                                    <table style={{ width: '96px', height: '61px', borderRadius: '12px', backgroundColor: "#FFFFFF", borderCollapse: 'collapse', display: screenWidth < MOBILE_VIEW_WIDTH ? "none" : "" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ display: 'flex', justifyContent: "center", alignItems: "left", flexDirection: "column", gap: "8px", padding: "8px" }}>
                                                                    <span onClick={isDateWithinThreeDays ? (e) => handleDeleteEntry(e, TimeTrackingRecordEntry.records[0], TimeTrackingRecordEntry.date) : undefined} style={{ ...styles.DropDownspan, cursor: isDateWithinThreeDays ? "pointer" : "not-allowed", color: isDateWithinThreeDays ? "#2F4858" : "#808080" }}>Delete entry</span>
                                                                    <span onClick={isDateWithinThreeDays ? (e) => handleAddNew(e) : undefined} style={{ ...styles.DropDownspan, cursor: isDateWithinThreeDays ? "pointer" : "not-allowed", color: isDateWithinThreeDays ? "#2F4858" : "#808080" }} >Add new</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}

                                            {TimeTrackingRecordEntry.records[0].uid === selectedRow.uid && (
                                                <div style={{ display: screenWidth < MOBILE_VIEW_WIDTH ? "flex" : "none", justifyContent: "space-between", alignItems: "center", backgroundColor: "#FFFFFF66", borderRadius: "30px", padding: "20px", marginBottom: "10px", position: "absolute", top: userDetailsScreen ? "95px" : "40px", left: "0", width: screenWidth < 425 ? "87%" : "90%", zIndex: 100 }}>
                                                    {handleAddClick ? (
                                                        isLoading ? (<ActivityIndicator
                                                            size="small"
                                                            color="#2F4858"
                                                        />) : (
                                                            <button style={{ backgroundColor: isAddButtonDisabled ? '#2F485880' : '#2F4858', color: '#FFFFFF', padding: '8px', borderRadius: '50px', cursor: isAddButtonDisabled ? '' : 'pointer', border: "none", outline: "none", width: "90px" }} onClick={handleAddNewEntry} disabled={isAddButtonDisabled}>
                                                                Add
                                                            </button>
                                                        )
                                                    ) : (
                                                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", }}>
                                                            <span onClick={isDateWithinThreeDays ? (e) => handleDeleteEntry(e, TimeTrackingRecordEntry.records[0], TimeTrackingRecordEntry.date) : undefined} style={{ ...styles.DropDownspan, cursor: isDateWithinThreeDays ? "pointer" : "not-allowed", color: isDateWithinThreeDays ? "#2F4858" : "#808080" }}>Delete entry</span>
                                                            <span onClick={isDateWithinThreeDays ? (e) => handleMobileAddNew(e) : undefined} style={{ ...styles.DropDownspan, cursor: isDateWithinThreeDays ? "pointer" : "not-allowed", color: isDateWithinThreeDays ? "#2F4858" : "#808080" }} >Add new</span>
                                                        </div>
                                                    )}
                                                    <svg onClick={() => {
                                                        setSelectedRow("")
                                                        setHandleAddClick(false);
                                                        setIsNewRowVisible(false);
                                                    }} width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M7.6488 6.5L12.762 1.38741C13.0793 1.07001 13.0793 0.555414 12.762 0.238046C12.4446 -0.0793487 11.93 -0.0793487 11.6126 0.238046L6.49998 5.35115L1.38741 0.238046C1.07001 -0.0793487 0.555417 -0.0793487 0.238046 0.238046C-0.0793233 0.555441 -0.0793487 1.07004 0.238046 1.38741L5.35116 6.5L0.238046 11.6126C-0.0793487 11.93 -0.0793487 12.4446 0.238046 12.7619C0.555439 13.0793 1.07004 13.0794 1.38741 12.7619L6.49998 7.64882L11.6126 12.7619C11.93 13.0794 12.4446 13.0794 12.7619 12.7619C13.0793 12.4445 13.0793 11.9299 12.7619 11.6126L7.6488 6.5Z" fill="#2F4858" />
                                                    </svg>
                                                </div>
                                            )}
                                        </tr>
                                        {
                                            TimeTrackingRecordEntry.records.slice(1).map((recordData: any) => (
                                                <tr
                                                    onContextMenu={(e) => handleRowClick(e, recordData, TimeTrackingRecordEntry.date)} key={recordData.uid}
                                                    onClick={screenWidth <= MOBILE_VIEW_WIDTH ? (e) => handleRowClick(e, recordData, TimeTrackingRecordEntry.date) : undefined}
                                                    style={{ backgroundColor: recordData.uid === selectedRow.uid ? '#0000FF33' : index % 2 === 0 ? '#2F48581A' : '#D8E6DC', position: screenWidth < MOBILE_VIEW_WIDTH ? undefined : "relative" }}>
                                                    <td></td>
                                                    <td style={tableDataStyle}>{recordData.projectName === projectName ? "" : recordData.projectName}{projectName = ""}</td>
                                                    <td style={tableDataStyle}></td>
                                                    <td style={styles.tableData1}>
                                                        <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                                            {recordData.startTime ? (
                                                                <>
                                                                    <img src={TimerStartIcon} alt="TimerStartIcon" width={25} height={25} />
                                                                    {
                                                                        formatTime(recordData.startTime, false)
                                                                    }
                                                                </>
                                                            ) : ""}
                                                        </span>
                                                    </td>
                                                    <td style={styles.tableData1}>
                                                        <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                                            {recordData.endTime ? (
                                                                <>
                                                                    <img src={TimerStopIcon} alt="TimerStopIcon" width={25} height={25} />
                                                                    {
                                                                        formatTime(recordData.endTime, false)
                                                                    }
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {recordData.startTime && !isToday && (
                                                                        <>
                                                                            <img src={warning} alt="warning" width={25} height={25} />
                                                                            <span>Add End Time</span>
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                        </span>
                                                    </td>
                                                    <td style={tableDataStyle}>
                                                        <TimeDurationColumn
                                                                record={{
                                                                duration: recordData.duration,
                                                                startTime: recordData.startTime,
                                                                endTime: recordData.endTime,
                                                                updatedAt: recordData.updatedAt
                                                            }}
                                                        date={TimeTrackingRecordEntry.date}
                                                        formatTimerDuration={formatTimerDuration}
                                                        isOnTime={isOnTime}
                                                        LateClockIcon={LateClockIcon}
                                                        />


                                                    </td>
                                                    <td style={{ ...tableDataStyle, maxWidth: "200px", wordBreak: "break-word" }}>
                                                        <HyperlinkSummary text={recordData.taskSummary || ''} />
                                                    </td>

                                                    {recordData.uid === selectedRow.uid && (
                                                        <div style={{ position: 'fixed', top: dropdownPosition.y, left: dropdownPosition.x, zIndex: 100 }}>
                                                            <table style={{ width: '96px', height: '61px', borderRadius: '12px', backgroundColor: "#FFFFFF", borderCollapse: 'collapse', display: screenWidth < MOBILE_VIEW_WIDTH ? "none" : "" }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td style={{ display: 'flex', justifyContent: "center", alignItems: "left", flexDirection: "column", gap: "8px", padding: "8px" }}>
                                                                            <span onClick={isDateWithinThreeDays ? (e) => handleDeleteEntry(e, recordData, TimeTrackingRecordEntry.date) : undefined} style={{ ...styles.DropDownspan, cursor: isDateWithinThreeDays ? "pointer" : "not-allowed", color: isDateWithinThreeDays ? "#2F4858" : "#808080" }}>Delete entry</span>
                                                                            <span onClick={isDateWithinThreeDays ? (e) => handleAddNew(e) : undefined} style={{ ...styles.DropDownspan, cursor: isDateWithinThreeDays ? "pointer" : "not-allowed", color: isDateWithinThreeDays ? "#2F4858" : "#808080" }} >Add new</span>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    )}
                                                    <div style={{ fontSize: 0, width: 0 }}>{projectName = recordData.projectName}</div>
                                                    {recordData.uid === selectedRow.uid && (
                                                        <div style={{ display: screenWidth < MOBILE_VIEW_WIDTH ? "flex" : "none", justifyContent: "space-between", alignItems: "center", backgroundColor: "#FFFFFF66", borderRadius: "30px", padding: "20px", marginBottom: "10px", position: "absolute", top: userDetailsScreen ? "95px" : "40px", left: "0", width: screenWidth < 425 ? "87%" : "90%", zIndex: 100 }}>
                                                            {handleAddClick ? (
                                                                isLoading ? (<ActivityIndicator
                                                                    size="small"
                                                                    color="#2F4858"
                                                                />) : (
                                                                    <button style={{ backgroundColor: isAddButtonDisabled ? '#2F485880' : '#2F4858', color: '#FFFFFF', padding: '8px', borderRadius: '50px', cursor: isAddButtonDisabled ? '' : 'pointer', border: "none", outline: "none", width: "90px" }} onClick={handleAddNewEntry} disabled={isAddButtonDisabled}>
                                                                        Add
                                                                    </button>
                                                                )
                                                            ) : (
                                                                <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", }}>
                                                                    <span onClick={isDateWithinThreeDays ? (e) => handleDeleteEntry(e, recordData, TimeTrackingRecordEntry.date) : undefined} style={{ ...styles.DropDownspan, cursor: isDateWithinThreeDays ? "pointer" : "not-allowed", color: isDateWithinThreeDays ? "#2F4858" : "#808080" }}>Delete entry</span>
                                                                    <span onClick={isDateWithinThreeDays ? (e) => handleMobileAddNew(e) : undefined} style={{ ...styles.DropDownspan, cursor: isDateWithinThreeDays ? "pointer" : "not-allowed", color: isDateWithinThreeDays ? "#2F4858" : "#808080" }} >Add new</span>
                                                                </div>
                                                            )}
                                                            <svg onClick={() => {
                                                                setSelectedRow("")
                                                                setHandleAddClick(false);
                                                                setIsNewRowVisible(false);
                                                            }} width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M7.6488 6.5L12.762 1.38741C13.0793 1.07001 13.0793 0.555414 12.762 0.238046C12.4446 -0.0793487 11.93 -0.0793487 11.6126 0.238046L6.49998 5.35115L1.38741 0.238046C1.07001 -0.0793487 0.555417 -0.0793487 0.238046 0.238046C-0.0793233 0.555441 -0.0793487 1.07004 0.238046 1.38741L5.35116 6.5L0.238046 11.6126C-0.0793487 11.93 -0.0793487 12.4446 0.238046 12.7619C0.555439 13.0793 1.07004 13.0794 1.38741 12.7619L6.49998 7.64882L11.6126 12.7619C11.93 13.0794 12.4446 13.0794 12.7619 12.7619C13.0793 12.4445 13.0793 11.9299 12.7619 11.6126L7.6488 6.5Z" fill="#2F4858" />
                                                            </svg>
                                                        </div>
                                                    )}
                                                </tr>
                                            ))
                                        }
                                        {TimeTrackingRecordEntry?.records.length > 1 && (
                                            <tr style={{ backgroundColor: index % 2 === 0 ? '#2F48581A' : '#D8E6DC' }}>
                                                <td style={{ display: screenWidth < MOBILE_VIEW_WIDTH ? 'none' : 'table-cell', padding: '15px' }}></td>
                                                <td style={tableDataStyle}></td>
                                                <td style={tableDataStyle}></td>
                                                <td style={tableDataStyle}></td>
                                                <td style={tableDataStyle}></td>
                                                <td style={{ ...tableDataStyle, fontWeight: 'bold', padding: "15px" }}>
                                                    {formatTimerDuration(totalDuration)}
                                                </td>
                                                <td style={tableDataStyle}></td>
                                            </tr>
                                        )}
                                    </React.Fragment>)
                            })}
                            {/* New row for adding entry */}
                            {isNewRowVisible && (
                                <>
                                    <tr id="newRowElement" style={{ backgroundColor: '#2F48581A' }}>
                                        <td style={{ display: screenWidth < MOBILE_VIEW_WIDTH ? 'none' : 'table-cell', padding: '15px' }}>{formatDate(recordEntryDate, "dddd")}</td>
                                        <td style={tableDataStyle}>
                                            <DropDownField
                                                isObjectList={true}
                                                value={newRowProjectName?.title}
                                                placeholder="Select Project Name"
                                                bodyStyle={{ marginHorizontal: 0, }}
                                                options={projectNameData}
                                                onChangeText={(selectedObj) => setNewRowProjectName(selectedObj)}
                                                label="Project Name"
                                            />
                                        </td>
                                        <td style={screenWidth < MOBILE_VIEW_WIDTH ? { padding: '15px' } : styles.tableData1}>{formatDate(recordEntryDate, "DD MMM, YY")}</td>
                                      <td style={styles.tableData1}>
                                      <input
                                                type="time"
                                                value={newRowStartTime}
                                                placeholder="Start time"
                                                onChange={(e) => setNewRowStartTime(e.target.value)}
                                                style={styles.tableInput}
                                            />
                                    </td>
                                        <td style={styles.tableData1}>
                                            <input
                                                type="time"
                                                value={newRowEndTime}
                                                placeholder="End time"
                                                onChange={(e) => setNewRowEndTime(e.target.value)}
                                                style={styles.tableInput}
                                            />
                                        </td>
                                        <td style={{ ...tableDataStyle, }}>
                                            <span style={{ alignSelf: "center" }}>{formatTimerDuration(calculateDuration(newRowStartTime, newRowEndTime))}</span>
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "20px", marginRight: "10px" }}>
                                                {isLoading ? (<ActivityIndicator
                                                    size="small"
                                                    color="#2F4858"
                                                />) : (
                                                    <button style={{ backgroundColor: isAddButtonDisabled ? '#2F485880' : '#2F4858', color: '#FFFFFF', padding: '8px', borderRadius: '50px', cursor: isAddButtonDisabled ? '' : 'pointer', border: "none", outline: "none", width: "50px" }} onClick={handleAddNewEntry} disabled={isAddButtonDisabled}>
                                                        Add
                                                    </button>
                                                )}
                                                <svg style={{ cursor: "pointer" }} onClick={() => setIsNewRowVisible(false)} width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.6488 6.5L12.762 1.38741C13.0793 1.07001 13.0793 0.555414 12.762 0.238046C12.4446 -0.0793487 11.93 -0.0793487 11.6126 0.238046L6.49998 5.35115L1.38741 0.238046C1.07001 -0.0793487 0.555417 -0.0793487 0.238046 0.238046C-0.0793233 0.555441 -0.0793487 1.07004 0.238046 1.38741L5.35116 6.5L0.238046 11.6126C-0.0793487 11.93 -0.0793487 12.4446 0.238046 12.7619C0.555439 13.0793 1.07004 13.0794 1.38741 12.7619L6.49998 7.64882L11.6126 12.7619C11.93 13.0794 12.4446 13.0794 12.7619 12.7619C13.0793 12.4445 13.0793 11.9299 12.7619 11.6126L7.6488 6.5Z" fill="#2F4858" />
                                                </svg>
                                            </div>
                                        </td>
                                        <td style={{ ...tableDataStyle, maxWidth: "200px", wordBreak: "break-word" }}>
                                            <textarea value={newRowTaskSummary} onChange={(e) => setNewRowTaskSummary(e.target.value)} placeholder="Enter Task Summary" style={styles.taskSummaryTextarea}>
                                            </textarea>
                                        </td>
                                    </tr>
                                    <tr id="mobileNewRowElement" style={{ backgroundColor: '#2F48581A' }}>
                                        <td style={{ display: screenWidth < MOBILE_VIEW_WIDTH ? 'table-cell' : 'none', padding: '15px' }}>{formatDate(recordEntryDate, "dddd")}</td>
                                        <td style={mobileTableDataStyle}>
                                            <DropDownField
                                                isObjectList={true}
                                                value={newRowProjectName?.title}
                                                placeholder="Select Project"
                                                bodyStyle={{ marginHorizontal: 0, }}
                                                options={projectNameData}
                                                onChangeText={(selectedObj) => setNewRowProjectName(selectedObj)}
                                                label="Project Name"
                                            />
                                        </td>
                                        <td style={mobileTableDataStyle}>
                                            <textarea value={newRowTaskSummary} onChange={(e) => setNewRowTaskSummary(e.target.value)} placeholder="Enter Task Summary" style={styles.taskSummaryTextarea}>
                                            </textarea>
                                        </td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </table>
                </div>
            </div >
            {showToast && (
                <Dialog
                    message={toastMessage}
                    onDialogClose={() => setShowToast(false)}
                    confirm={true}
                    isDialogVisible={showToast}
                    handleDialogConfirm={handleConfirm}
                    confirmText="Yes"
                    title="Time Tracking"
                    cancelText="No"
                />
            )
            }
            {
                showAlertToast && (
                    <Dialog
                        message={toastMessage}
                        onDialogClose={() => setShowAlertToast(false)}
                        isDialogVisible={showAlertToast}
                        confirmText="Okay"
                        title="Alert"
                    />
                )

            }
        </>
    )
}

export default TimeTrackingTable

const styles = StyleSheetRW.create(() => ({
    buttonStyle: {
        backgroundColor: '#2F4858',
        borderWidth: 0,
        paddingBottom: 10,
        paddingTop: 10,
        paddingLeft: 20,
        paddingRight: 20,
        cursor: 'pointer',
        position: 'absolute',
        right: 0,
        borderRadius: 100,
    },
    buttonText: {
        color: 'white',
        fontWeight: "300",
        textAlign: "center"
    },
    tableHeading: { fontSize: 20, fontWeight: 'bold', marginBottom: '10px' },
    tableHead: { padding: '15px', textAlign: 'left', borderBottom: '1px solid #2F4858', fontWeight: '300', fontSize: 14 },
    tableStyle: { width: "100%", borderCollapse: 'collapse', backgroundColor: '#FFFFFF66' },
    tableData1: { padding: '15px', borderLeft: '1px solid #2F485880', whiteSpace: "wrap", },
    DropDownspan: { fontFamily: "Outfit", fontSize: 14, fontWeight: "300", textAlign: "left", color: "#2F4858", },
    tableInput: { backgroundColor: '#0000000D', border: "none", outline: "none", color: '#2F4858', padding: '8px', borderRadius: 10, width: "100px" },
    taskSummaryTextarea: {
        width: '90%',
        padding: '5px',
        border: '1px solid #ccc',
        borderRadius: 5,
        fontSize: '14px',
        resize: "none",
        fontFamily: "Outfit"
    }
}))